import type { Table } from '@tanstack/react-table'

import Button from '@components/atoms/Button'
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@components/atoms/DropdownMenu'
import { scopedTranslation } from '@frontend/utils/I18n'

const t = scopedTranslation('components.column_visibility')

type ColumnVisibilityDropdownProps<TData> = {
  table: Table<TData>
  nonHideableColumns?: string[]
}

export function ColumnVisibilityDropdown<TData>({
  table,
  nonHideableColumns = [],
}: ColumnVisibilityDropdownProps<TData>) {
  const columns = table.getAllColumns().filter((column) => !nonHideableColumns.includes(column.id))

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button rank="secondary" trailingIcon="chevron-down">
          {t('select_columns')}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {columns.map((column) => (
          <DropdownMenuCheckboxItem
            key={column.id}
            checked={column.getIsVisible()}
            onCheckedChange={(checked) => column.toggleVisibility(checked)}
            onSelect={(event) => event.preventDefault()}
          >
            {typeof column.columnDef.header === 'string' ? column.columnDef.header : column.id}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
